// Central place for logos / brand assets.
// Primary Dyntra Store logo — white-background version, shipped locally so we
// don't depend on the Emergent CDN and get instant swaps for TopBar / Footer /
// AuthDialog headers.
export const DYNTRA_LOGO_URL = "/logo/logo2.png";
export const DYNTRA_LOGO_ALT_URL = "/logo/logo1.png";
